import {
  CollectionActions,
  CollectionStateSlice,
  mergeDocuments,
  mergeWebsocketDocuments,
  transformIntoDocuments,
  updateWebsocketDocuments,
} from '@freelancer/datastore/core';
import {
  transformContestComment,
  transformMessageApiToContestComment,
} from './contest-comments.transformers';
import { ContestCommentsCollection } from './contest-comments.types';

export function contestCommentsReducer(
  state: CollectionStateSlice<ContestCommentsCollection> = {},
  action: CollectionActions<ContestCommentsCollection>,
) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'contestComments') {
        const { result, ref, order } = action.payload;
        if (result.comments) {
          return mergeDocuments<ContestCommentsCollection>(
            state,
            transformIntoDocuments(result.comments, transformContestComment),
            order,
            ref,
          );
        }
        return state;
      }
      return state;
    }

    case 'API_UPDATE_SUCCESS': {
      if (action.payload.type === 'contestComments') {
        const { originalDocument, ref, delta, result } = action.payload;

        // FIXME: T180433 Fix repliesCount and update method of
        // checking if comment is a parent comment
        const newState =
          originalDocument.parentId &&
          originalDocument.isDeleted &&
          !delta.isDeleted
            ? updateWebsocketDocuments<ContestCommentsCollection>(
                state,
                [originalDocument.parentId],
                comment => ({
                  ...comment,
                  repliesCount: (comment.repliesCount || 0) + 1,
                }),
                ref,
              )
            : state;

        return mergeWebsocketDocuments<ContestCommentsCollection>(
          newState,
          transformIntoDocuments(
            [
              {
                ...result.comment,
                // FIXME: T180722 Remove this once API endpoint has been updated to
                // to return replies count
                replies_count: originalDocument.repliesCount,
              },
            ],
            transformContestComment,
          ),
          ref,
        );
      }
      return state;
    }

    case 'API_PUSH_SUCCESS': {
      if (action.payload.type === 'contestComments') {
        const { ref, rawRequest, result } = action.payload;

        // FIXME: T180433 Fix repliesCount and update method of
        // checking if comment is a parent comment
        const newState = rawRequest.parent_id
          ? updateWebsocketDocuments<ContestCommentsCollection>(
              state,
              [rawRequest.parent_id],
              comment => ({
                ...comment,
                repliesCount: (comment.repliesCount || 0) + 1,
              }),
              ref,
            )
          : state;

        // The endpoint we use for posting new ContestComments is the old
        // ContestMessage endpoint, which returns in the type
        // MessageApi, so here we use transformMessageApiToContestComment
        return mergeWebsocketDocuments<ContestCommentsCollection>(
          newState,
          transformIntoDocuments(
            [result.message],
            transformMessageApiToContestComment,
            result.sender.id,
          ),
          ref,
        );
      }
      return state;
    }

    case 'API_DELETE_SUCCESS': {
      if (action.payload.type === 'contestComments') {
        const { originalDocument, ref } = action.payload;

        // FIXME: T180433 Fix repliesCount and update method of
        // checking if comment is a parent comment
        const newState = originalDocument.parentId
          ? updateWebsocketDocuments<ContestCommentsCollection>(
              state,
              [originalDocument.parentId],
              comment => ({
                ...comment,
                repliesCount: (comment.repliesCount || 1) - 1,
              }),
              ref,
            )
          : state;

        return updateWebsocketDocuments<ContestCommentsCollection>(
          newState,
          [originalDocument.id],
          _ => ({ ...originalDocument, isDeleted: true }),
          ref,
        );
      }
      return state;
    }

    default:
      return state;
  }
}
